import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupSettingsIntegration" */ './lazyIndex'),
    { name: 'GroupSettingsIntegration' }
);

export const lazyOpenGroupSettings: LazyAction<
    typeof lazyIndex.openGroupSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openGroupSettings);
